// extracted by mini-css-extract-plugin
export default {"checkbox":"GenCheckbox_checkbox__99xuw","icon":"GenCheckbox_icon__2v0Mv"};